import { IRegisterFormData } from '@adex/shared/models/auth/register-form-data'
import { IModelUserDto } from '@adex/shared/models/dto/user.dto'
import { IUser } from '@adex/shared/models/user'


export function registerFormDataToUserDto(data: IRegisterFormData): IModelUserDto {
  const { email, specifics, country, city, address, firstName, lastName, phoneNumber, messenger, vat, companyName, messengerType } = data
  return {
    user: {
      login: email,
      emailConfirmed: false,
      details: {
        values: {
          firstName, lastName, companyName,
          isCompany: specifics === 'company',
          phone: phoneNumber,
          country, city, address, messenger, email, vat, messengerType
        }
      }
    }
  }
}

export function userDtoToUser(userDto: IModelUserDto): IUser {
  const { login, emailConfirmed, passwordSet, username, id, isActive, isSubscription, isPostPay, roles, trackingToken, adpAdvertiserId, createdAt, trialActivated } = userDto.user
  const { isCompany, city, country, address, firstName, lastName, email, phone, messenger, messengerType } = userDto.user.details.values
  return {
    id, login, emailConfirmed, passwordSet,
    isCompany, city, country, address,
    firstName, lastName, email, phone, messenger,
    username, isActive, roles, trackingToken,
    adpAdvertiserId, createdAt, messengerType,
    isSubscription, trialActivated, isPostPay
  }
}
